import chalk from 'chalk'
import { AdditionalParams, LogLevel, LogMessage, LoggerBackend } from './logger'
import { getObjectKeys, notNull, runIfDefined } from './tools'
import { enumKeyToString } from './enumTools'

export class ConsoleLogger implements LoggerBackend {
  constructor(private opts?: { level?: LogLevel; filter?: (msg: LogMessage) => boolean }) {}

  isLevelEnabled(level: LogLevel): boolean {
    if (!this.opts?.level) return true
    return level >= this.opts.level
  }

  write(msg: LogMessage): void {
    if (!this.isLevelEnabled(msg.level)) return
    if (this.opts?.filter && !this.opts.filter(msg)) return
    let logFunc: (message: string, ...params: unknown[]) => void
    let levelColor
    switch (msg.level) {
      case LogLevel.DEBUG:
        // eslint-disable-next-line no-console
        logFunc = console.log
        levelColor = chalk.blueBright
        break
      case LogLevel.INFO:
        // eslint-disable-next-line no-console
        logFunc = console.info
        levelColor = chalk.green
        break
      case LogLevel.WARN:
        // eslint-disable-next-line no-console
        logFunc = console.warn
        levelColor = chalk.yellow
        break
      case LogLevel.ERROR:
        // eslint-disable-next-line no-console
        logFunc = console.error
        levelColor = chalk.red
        break
    }

    let traceId: string | undefined
    let filteredParams: AdditionalParams | undefined
    if (msg.params) {
      for (const k of getObjectKeys(msg.params)) {
        const v = msg.params[k]
        if (v || v === null) {
          if (k === 'traceId') {
            traceId = v as string
          } else {
            if (!filteredParams) filteredParams = {}
            filteredParams[k] = v
          }
        }
      }
    }

    let levelStr = enumKeyToString(LogLevel, msg.level)
    levelStr = levelStr + ' '.repeat(5 - levelStr.length)

    const date = new Date().toISOString()

    const message = [
      chalk.gray(date),
      `[${levelColor.bold(levelStr)}]`,
      runIfDefined(traceId, it => `[tid: ${chalk.blueBright(it)}]`),
      `${chalk.whiteBright(msg.module)}: ${levelColor(msg.msg)}`,
    ]
      .filter(notNull)
      .join(' ')

    if (filteredParams) logFunc(message, filteredParams)
    else logFunc(message)
  }
}
